/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartialPaymentDto } from '../../models/partial-payment-dto';

export interface DeletePartialPayment$Params {

/**
 * customer GUID from svgzapi-core
 */
  customerGUID: string;
}

export function deletePartialPayment(http: HttpClient, rootUrl: string, params: DeletePartialPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<PartialPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, deletePartialPayment.PATH, 'delete');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartialPaymentDto>;
    })
  );
}

deletePartialPayment.PATH = '/partialpayments';
